import React from 'react'
import { ImageCard } from './style'

export default ({ children, isHorizontal }) => (
  <ImageCard isHorizontal={isHorizontal}>{children}</ImageCard>
)
